import React from 'react';

import { Box, ButtonGroup } from '@mui/material';

import { FORM_FIELD_TYPES, FormField } from '../../../components/form/form-field';
import SaveButton from '../../../components/form/save-button';

const ReadTextForm = ({ form, onSubmit, onChange }) => {
  const { errors } = form.formState;
  const formControl = form.control;

  return (
    <Box
      component="form"
      onSubmit={form.handleSubmit(onSubmit)}
      onReset={form.reset}
      onChange={onChange}
    >
      <FormField
        controlId="readTextFormName"
        label="name"
        name="name"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter name"
        required
        error={errors.name?.message}
      />
      <FormField
        controlId="readTextFormType"
        label="type"
        name="type"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        disabled
        error={errors.type?.message}
      />

      <FormField
        controlId="readTextFormColumnName"
        label="columnName"
        name="properties.columnName"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter column name"
        error={errors.properties?.columnName?.message}
      />
      <FormField
        controlId="readTextFormTreatEmptyValuesAsNulls"
        label="treatEmptyValuesAsNulls"
        name="properties.treatEmptyValuesAsNulls"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.CHECKBOX}
      />
      <FormField
        controlId="readTextFormInferSchema"
        label="inferSchema"
        name="properties.inferSchema"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.CHECKBOX}
      />
      <FormField
        controlId="readTextFormTimestampFormat"
        label="timestampFormat"
        name="properties.timestampFormat"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter timestamp format"
        error={errors.properties?.timestampFormat?.message}
      />
      <FormField
        controlId="readTextFormExcerptSize"
        label="excerptSize"
        name="properties.excerptSize"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter excerpt size"
        error={errors.properties?.excerptSize?.message}
      />
      <ButtonGroup>
        <SaveButton />
      </ButtonGroup>
    </Box>
  );
};

export default ReadTextForm;
